import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { countries, CountryType } from './CountryCodes';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

export default function CountrySelect(props: { countryCode: CountryType,setCountryCode: React.Dispatch<React.SetStateAction<CountryType>>, className?: string, params?: { size?: "small" | "medium", width?: string }}) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Manage Update Access"
  return (
    <Autocomplete
      id="country-select-demo"
      className={props.className}
      onChange={(event,value) => {
        if(value!==null) props.setCountryCode(value);
      }}  
      value={props.countryCode}
      options={countries}
      autoHighlight
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label} ({option.code}) +{option.phone}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={translate(TranslationEnum.manage_update_access,"Choose a country")}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
      {...props.params}
    />
  );
}